<template>
  <el-dialog
    title="申报附件下载"
    :visible.sync="visible"
    width="45%"
    :close-on-click-modal="false"
    :before-close="close"
  >
    <el-table
      stripe
      v-loading="listLoading"
      :data="tableData"
      :header-cell-style="{ background: '#EDF7FE' }"
      element-loading-text="使劲加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      border
      row-key="id"
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column type="selection" width="55" /> -->
      <el-table-column label="序号" type="index" width="50" align="center" />
      <el-table-column prop="id" label="id" align="center" />
      <el-table-column prop="createTime" label="重传日期" align="center" />
      <el-table-column label="类型" align="center" >
        <template slot-scope="scope">
          <span>{{ getTypeText(scope.row.fileProperty) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="附件" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            :loading="singleDownloading && singleIndex === scope.$index"
            @click="showDownloadDialog('single', scope.row)"
            >下载</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div slot="footer" class="dialog-footer">
      <!-- <el-button
        v-if="tableData.length > 0"
        type="primary"
        :loading="allDownloading"
        @click="allDownload"
        >下载全部</el-button
      >
      <el-button
        v-if="tableData.length > 0"
        type="primary"
        :loading="allDownloading"
        @click="selectedDownload"
        >下载选中</el-button
      > -->
      <el-button @click.native="close">取消</el-button>
    </div>

    <!-- 导出对话框 -->
      <el-dialog title="文件名称" :visible.sync="downloadVisible" width="40%" :close-on-click-modal="false" @before-close="closeDownloadDialog" append-to-body>
        <el-form label-width="120px" >
          <el-form-item label="文件名称">
            <el-input v-model.trim="downloadFilename" placeholder="请输入下载文件名称" maxlength="120" @blur="check_filename($event)" clearable></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="closeDownloadDialog">取消</el-button>
          <el-button type="primary" @click="singleDownload" :loading="singleDownloading">确定</el-button>
        </div>
      </el-dialog>
  </el-dialog>
</template>
<script>
import {
  declareDownload,
  restoreUploadQuery,
  originDownload,
  restoreOriginQuery,
} from "@/api/crossborder/declare/restore/restore";
import File from "@/utils/file";
export default {
  props: {},
  data: function () {
    return {
      visible: false,
      declareNo: null,
      merNo: null,

      allDownloading: false,

      listLoading: false, // 表格的加载状态
      tableData: [],

      multipleSelection: [],

      singleIndex: 0,
      singleDownloading: false,

      // 导出变量
      downloadType: null, // single multiple
      downloadId: null, // 如果是single的话，需要传递id
      downloadLoading: false,
      downloadVisible: false,
      downloadFilename: null,
      downloadFilePath: null,  // 这个路径带有后缀名称，我可以用于计算后缀

      fileTypes: [
        { label: '发票', value: '02' },
        { label: '合同', value: '03' },
        { label: '报关单', value: '05' },
        { label: '物流单', value: '06' },
        { label: '其他', value: '07' },
      ]
    };
  },

  methods: {

    // 文件名称有些特殊符号不能使用，替换成''
    check_filename(event) {
      this.downloadFilename = event.target.value.replace(/[\\\\/:*?\"<>|@]/g, '')
    },

    getTypeText(type){
      let res = ''
      this.fileTypes.forEach(item=>{
        if(item.value === type){
          res = item.label
        }
      })
      return res
    },

    open(row) {
      // console.log("我接收到row----------------", row);
      this.declareNo = row.declareNo;
      this.visible = true;
      this.getTableData();
    },

    close() {
      this.visible = false;
      this.declareNo = null;
      this.tableData = [];
      this.allDownloading = false;
      this.singleDownloading = false;
      this.singleIndex = 0;
    },

    getTableData() {
      this.tableData = [];
      this.listLoading = true;
      restoreOriginQuery({ declareNo: this.declareNo })
        .then((res) => {
          this.listLoading = false;
          if (res.data) this.tableData = res.data;
        })
        .catch((err) => {
          this.listLoading = false;
          console.log("查询错误", err);
        });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    showDownloadDialog(type, row) {
      
      this.downloadVisible = true
      this.downloadFilename = null
      this.downloadType = type
      this.downloadFilePath = row.remark
      if(row){
        this.downloadId = row.id
      }
    },

    closeDownloadDialog() {
      this.downloadVisible = false
      this.downloadFilename = null
      this.downloadId = null
      this.downloadType = null
      this.downloadFileType = null
    },

    confirmDownload() {
      let param;
      if (this.downloadType === "single") {
        param = {
          id: this.downloadId,
          declareNo: this.declareNo,
          recordUser: this.$store.getters.merNo,
          fileName: this.downloadFilename,
          recordType: "2",
          moduleName: "00",
        };
      } else if (this.downloadType === "multiple") {
        param = {
          id: null,
          declareNo: this.declareNo,
          recordUser: this.$store.getters.merNo,
          fileName: this.downloadFilename,
          recordType: "2",
          moduleName: "00",
        };
      }

      this.downloadLoading = true;
      declareDownload(param)
        .then((res) => {
          this.downloadLoading = false;
          this.downloadFilename = null;
          this.downloadVisible = false;
          this.downloadId = null;
          this.$message.success("处理中，请稍候前往文件下载页面查看");
          // File.output(res)
        })
        .catch((err) => {
          this.downloadLoading = false;
          console.log("下载出错", err);
        });
    },

    singleDownload() {

      if(!this.downloadFilename){
        this.$message.error('请填写文件名称')
        return
      }
      if(!this.downloadId){
        this.$message.error('缺失文件id')
        return
      }
      
      this.singleDownloading = true;
      originDownload({id: this.downloadId, fileName: this.downloadFilename})
        .then((res) => {
          this.singleDownloading = false;
          File.output(res);
          this.closeDownloadDialog();
        })
        .catch((err) => {
          this.singleDownloading = false;
          console.log("下载出错", err);
        });
    },

    selectedDownload() {
      if (this.multipleSelection.length === 0) {
        this.$message.error("当前没有选中的文件");
        return;
      }

      this.$confirm("请问你需要下载选中文件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.multipleSelection.forEach((item, index) => {
          originDownload({ id: item.id })
            .then((res) => {
              File.output(res);
            })
            .catch((err) => {
              console.log("第" + index + "项文件下载失败", err);
            });
        });
      });
    },

    allDownload() {
      this.$confirm("请问你需要一次性下载全部文件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.tableData.forEach((item, index) => {
          originDownload({ id: item.id })
            .then((res) => {
              File.output(res);
            })
            .catch((err) => {
              console.log("第" + index + "项文件下载失败", err);
            });
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
